import { render, staticRenderFns } from "./AppRadio.vue?vue&type=template&id=52ec5e9a&"
import script from "./AppRadio.vue?vue&type=script&lang=js&"
export * from "./AppRadio.vue?vue&type=script&lang=js&"
import style0 from "./AppRadio.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports